module.exports = __webpack_public_path__ + "img/hgryp.c568b6db.jpg";